import {
  Box,
  Card,
  CardBody,
  Divider,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaUsers, FaCalendarAlt, FaDollarSign,FaUser } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export const CorporateCard = (props: any) => {
  const {
    access_code,
    contract_start_date,
    contract_end_date,
    onboarded_users,
    bookings,
    all_session_price,
    cap,
    corporate_credits,
    current_corporate_balance,
    restricted_therapists,
    specific_therapist_list,
    session_type_restriction,
    single_session_discount,
    subscription_session_discount,
    instant_therapy_session_discount
  } = props;

  function convertDate(dateStr: any) {
    if (!dateStr) return "";
    const [ year, month,day] = dateStr.split("-");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const shortYear = year.slice(-2);

    const monthName = monthNames[parseInt(month, 10) - 1];

    // Return the formatted date string
    return `${parseInt(day, 10)} ${monthName} ${shortYear}`;
  }
  const cardBg = useColorModeValue("white", "gray.800");

  const cardShadow = useColorModeValue("md", "dark-lg");
  const sectionHeadingColor = useColorModeValue("gray.600", "gray.300");
  const highlightColor = useColorModeValue("#e4ae2f", "#fdb508");
  const iconColor = useColorModeValue("teal.500", "teal.300");

  const Highlight = ({ children }: any) => (
    <Box as="span" fontWeight="bold" color={highlightColor}>
      {children}
    </Box>
  );

  return (
    <Card
      width="xxl"
      bg={cardBg}
      boxShadow={cardShadow}
      borderRadius="lg"
      p={6}
    >
      <CardBody>
        <Stack spacing={6}>
          <Heading size="lg" textAlign="center">
            {access_code}
          </Heading>
          <Divider />

          <Flex justify="space-between" flexWrap="wrap">
            <Text flex="1">
              <Icon as={FaCalendarAlt} color={iconColor} mr={2} />
              Contract start date:{" "}
              <Highlight>{convertDate(contract_start_date)}</Highlight>
            </Text>
            <Text flex="1">
              <Icon as={FaCalendarAlt} color={iconColor} mr={2} />
              Contract end date:{" "}
              <Highlight>{convertDate(contract_end_date)}</Highlight>
            </Text>
          </Flex>

          <Flex justify="space-between" flexWrap="wrap">
            <Text flex="1">
              <Icon as={FaUsers} color={iconColor} mr={2} />
              No. of onboarded users:{" "}
              <Highlight>{onboarded_users.length}</Highlight>
            </Text>
            <Text flex="1">
              <Icon as={FaUsers} color={iconColor} mr={2} />
              No. of booked sessions: <Highlight>{bookings}</Highlight>
            </Text>
          </Flex>

          <Flex justify="space-between" flexWrap="wrap">
            <Text flex="1">
              <Icon as={FaDollarSign} color={iconColor} mr={2} />
              All session price: <Highlight>{all_session_price ===null? "NA": `₹${all_session_price}`}</Highlight>
            </Text>
            <Text flex="1">
              <Icon as={FaDollarSign} color={iconColor} mr={2} />
              Price Cap: <Highlight>{cap >=30000? "NA": `₹${cap}`}</Highlight>
            </Text>
          </Flex>

          <Flex justify="space-between" flexWrap="wrap">
            <Text flex="1">
              <Icon as={FaDollarSign} color={iconColor} mr={2} />
              Corporate credits: <Highlight>{!corporate_credits? "NA": `₹${corporate_credits}`}</Highlight>
            </Text>
            <Text flex="1">
              <Icon as={FaDollarSign} color={iconColor} mr={2} />
              Current corporate balance: <Highlight>{!current_corporate_balance? "NA": `₹${current_corporate_balance}`}</Highlight>
            </Text>
          </Flex>

          <Stack spacing={4}>
            <Box>
              <Heading size="md" color={sectionHeadingColor}>
                Therapists
              </Heading>
              <Flex justify="space-between" flexWrap="wrap">
                <Box flex="1">
                  <Text fontWeight="bold">
                    Restricted therapists: <Highlight>{restricted_therapists.length}</Highlight>
                  </Text>
                  {restricted_therapists.map((el:any)=><Text key={el.email}>
                    <Icon as={FaUser} color={iconColor} mr={2} />
                   {el.name}
                  </Text>) 
                 }
                 
                </Box>
                <Box flex="1">
                  <Text fontWeight="bold">
                    Specific therapists: <Highlight>{specific_therapist_list.length}</Highlight>
                  </Text>
                  {specific_therapist_list.map((el:any)=><Text key={el.email}>
                    <Icon as={FaUser} color={iconColor} mr={2} />
                   {el.name}
                  </Text>) 
                 }
                </Box>
              </Flex>
            </Box>
            <Box>
              <Heading size="sm" color={sectionHeadingColor}>
                Session Restrictions
              </Heading>
              <Flex justify="space-between" flexWrap="wrap">
                <Box flex="1">
                  <Text>
                    Session types: <Highlight>{session_type_restriction.join(", ")}</Highlight>
                  </Text>
                </Box>
                <Text flex="1">
                  
                  Instant therapy discount: <Highlight>{!instant_therapy_session_discount? "NA": `${instant_therapy_session_discount}%`}</Highlight>
                </Text>
              </Flex>
            </Box>

            <Box>
              <Heading size="sm" color={sectionHeadingColor}>
                Discounts
              </Heading>
              <Flex justify="space-between" flexWrap="wrap">
                <Text flex="1">
                
                  Single session discount: <Highlight>{!single_session_discount? "NA": `₹${single_session_discount}%`}</Highlight>
                </Text>
                <Text flex="1">
                
                  Subscription session discount: <Highlight>{!subscription_session_discount? "NA": `₹${subscription_session_discount}%`}</Highlight>
                </Text>
              </Flex>
            </Box>
          </Stack>
        </Stack>
      </CardBody>
    </Card>
  );
};
